import { FC, useCallback } from "react";
import { TablePagination } from "@mui/material";
import { setExecutionLogPagination } from "../../../../../store/execution-log/executionLogSlice";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { executionLogDataSelector } from "../../../../../store/execution-log/selectors/executionLogDataSelector";
import { executionLogPaginationSize } from "../../utils/constants/common";
import { getExecutionLogThunk } from "../../../../../store/execution-log/thunks/getExecutionLogThunk";

export const ExecutionLogsDataGridPagination: FC = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(executionLogDataSelector);

  const pageChangeHandler = useCallback(
    (_: any, newPage: any) => {
      dispatch(setExecutionLogPagination({ page: newPage }));
      dispatch(getExecutionLogThunk());
    },
    [dispatch],
  );

  return (
    <TablePagination
      component="div"
      count={data?.total_items ?? 0}
      page={data?.current_page ?? 0}
      rowsPerPageOptions={[]}
      onPageChange={pageChangeHandler}
      rowsPerPage={executionLogPaginationSize}
    />
  );
};
